export const FETCH_FLOW_ADMIN_RCA_REPORTS_INIT = 'FETCH_FLOW_ADMIN_RCA_REPORTS_INIT';
export const FETCH_FLOW_ADMIN_RCA_REPORTS_SUCCESS = 'FETCH_FLOW_ADMIN_RCA_REPORTS_SUCCESS';
export const FETCH_FLOW_ADMIN_RCA_REPORTS_FAILURE = 'FETCH_FLOW_ADMIN_RCA_REPORTS_FAILURE';

export const RESET_FLOW_ADMIN_RCA_REPORTS = 'RESET_FLOW_ADMIN_RCA_REPORTS';
export const SET_FILTER_FLOW_ADMIN_RCA_REPORTS = 'SET_FILTER_FLOW_ADMIN_RCA_REPORTS';



// WEBPACK FOOTER //
// ./source/client/actions/flow_admin_rca_reports/types.js